<template>
  <div>
    <div v-if="trackerStatus">
      <div v-if="trackerStatus && trackerStatus.status">
        <div>
          <span style="color: #be6837">Name: </span>{{ trackerStatus.lcuName }}
          <span style="color: #be6837">Code: </span>{{ trackerStatus.lcuCode }}
          <span style="color: #be6837">Status: </span>{{ trackerStatusMessage }}
        </div>
        <div v-if="tracker.tracker_type === 1">
          <div v-for="index in 4" :key="index">
            <div v-if="trackerStatus.armErrors[index - 1] && trackerStatus.lastStatusCollection <= 600">
              <span style="color: #be6837">Armature {{ index }}: </span>{{ trackerStatus.armErrors[index - 1].name }}
            </div>
            <div v-else>
              <span style="color: #be6837">Armature {{ index }}: </span>Unknown
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(arm, index) in tracker.arms" :key="index">
            <div v-if="trackerStatus.armErrors[arm.pos - 1] && trackerStatus.lastStatusCollection <= 600">
              <span style="color: #be6837">Armature {{ arm.pos }}: </span>{{ trackerStatus.armErrors[arm.pos - 1].name }}
            </div>
            <div v-else>
              <span style="color: #be6837">Armature {{ arm.pos }}: </span>Unknown
            </div>
          </div>
        </div>
        <div style="color: grey; font-size: 11px;">Last collection {{ lastCollection }}</div>
      </div>
      <div v-else>
        <span style="color: #be6837">Name: </span>{{ trackerStatus.lcuName }}
        <span style="color: #be6837">Code: </span>{{ trackerStatus.lcuCode }}
        <span style="color: #be6837">Status: </span>Default
      </div>
    </div>
    <div v-else>
      <span style="color: #be6837">Status: </span>Loading..
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { setInterval, clearInterval } from 'timers';

let intervalId = null;

export default {
  name: 'TrackerInfo',
  props: {
    tracker: {
      type: Object,
      required: true
    },
    trackerStatus: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lastStatusUpdate: moment(),
      dummy: false
    };
  },
  computed: {
    trackerStatusMessage() {
      if (this.trackerStatus && this.trackerStatus.status) {
        if (this.trackerStatus.status.description !== 'Unknown' && this.trackerStatus.lastStatusCollection <= 600) return this.trackerStatus.status.description;
      }
      
      return 'No Response';
    },
    lastCollection() {
      this.dummy;

      if (this.trackerStatus && this.trackerStatus.status) {
        if (this.trackerStatus.lastStatusCollection >= 0) return moment(this.lastStatusUpdate).subtract(this.trackerStatus.lastStatusCollection, 'seconds').fromNow();
      }

      return 'never';
    }
  },
  watch: {
    trackerStatus() {
      this.lastStatusUpdate = moment();
    }
  },
  mounted() {
    intervalId = setInterval(() => {
      this.dummy = !this.dummy;
    }, 5000);
  },
  beforeDestroy() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }
};
</script>